import {
  axiosAccountGprocessPrivateV2,
  axiosAccountPrivate,
  axiosAccountPrivateDomainV2,
  axiosAccountPrivateV2,
} from "./axios";
import { RequestApiGticket } from "../features/gticket/api/axios";
import { RequestApiPrivateQuickTicket } from "../features/system-management/api/axios";
import axios from "axios";
import { fetchWithEtagSafe } from "../utils/etagUtils";
import { withSsoAuthorization } from "../helpers/auth";

let source: any = null;

export const cancelToken = () => cancel(source);

export function cancel(source: any) {
  source && source.cancel && source.cancel("Unmount");
}
export const AccountApi = {
  getListDepartment: async (): Promise<any> => {
    try {
      const res = await axiosAccountPrivate.get("/department");
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  checkOwnerAndConcurrenlyOfWorkSpace: async (params: any): Promise<any> => {
    try {
      const res = await axiosAccountPrivateV2.get("/users/direct-managements", {
        params,
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  getLoginUserQrCodes: async (): Promise<any> => {
    try {
      const res = await RequestApiPrivateQuickTicket.get("/users/qr-codes");
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  getUserWorkProcess: async (id: any): Promise<any> => {
    try {
      const res = await axiosAccountPrivateV2.get(
        `/users/${id}/working-process`
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  getWorkspaceOwnTicket: async (id: any): Promise<any> => {
    try {
      const res = await axiosAccountPrivateV2.get(
        `/users/info/${id}?relations[]=workspace`
      );
      return res?.data?.data;
    } catch (error) {
      throw error;
    }
  },
  getListSBU: async (): Promise<any> => {
    try {
      const res = await axiosAccountPrivateV2.get("/sbu-info");
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  getUserSameLevels: async (userID: number): Promise<any> => {
    try {
      const res = await axiosAccountPrivate.get(
        `users/list-user-same-level?user_id=${userID}`
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  createNewDepartment: async (department: any): Promise<any> => {
    try {
      const res = await axiosAccountPrivate.post(
        "/admin/departments",
        department || {}
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  getListTitles: async (): Promise<any> => {
    try {
      const res = await axiosAccountPrivate.get("/department?type=select");
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  updateDepartmentInfo: async (department: any, _id: number): Promise<any> => {
    try {
      const res = await axiosAccountPrivate.put(
        `/admin/departments/${_id}`,
        department || {}
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  getListGroups: async (): Promise<any> => {
    try {
      const params = {
        with: ["leader", "users"],
      };

      const res = await fetchWithEtagSafe(
        axiosAccountGprocessPrivateV2,
        "/selection-teams",
        { params },
        "selectionTeams"
      );

      return res.data;
    } catch (error) {
      throw error;
    }
  },
  getListWorkspaces: async (): Promise<any> => {
    try {
      const res = await fetchWithEtagSafe(
        axiosAccountPrivateV2,
        "/workspaces",
        { params: { additional_job_title: true } },
        "workspaces"
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  createNewDvision: async (_division: any = {}): Promise<any> => {
    try {
      const res = await axiosAccountPrivate.post("/admin/divisions", _division);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  updateDivisionInfoById: async (
    _division: any = {},
    _id: number
  ): Promise<any> => {
    try {
      const res = await axiosAccountPrivate.put(
        `/admin/divisions/${_id}`,
        _division
      );
    } catch (error) {
      throw error;
    }
  },
  getListRoles: async (): Promise<any> => {
    try {
      const res = await axiosAccountPrivateV2.get("/roles");
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  getAdminUsers: async function (): Promise<any> {
    try {
      const response = await axiosAccountPrivate.get("/admin/users");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * `POST /api/auth/generate-token` (Account service) — xác thực bằng SSO access token.
   * Endpoint nằm ngoài prefix `/api/v1` của `axiosAccountPrivate` nên override `baseURL`
   * theo request (vẫn giữ header/api-key của instance).
   * Token trả về (`data.token`) là token nội bộ dùng cho mọi axios instance account
   * (thay cho `token` từng trả kèm trong `info-by-username`).
   */
  generateToken: async function (
    email: string,
    ssoAccessToken: string
  ): Promise<any> {
    try {
      const response = await axiosAccountPrivate.post(
        "/auth/generate-token",
        { email },
        {
          ...withSsoAuthorization(ssoAccessToken),
          baseURL: process.env.REACT_APP_API_ACCOUNT_BASE_URL + "/api",
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /** `POST /api/v2/users/info-by-username` — xác thực bằng SSO access token. */
  getUserInfo: async function (
    payload: any,
    ssoAccessToken: string
  ): Promise<any> {
    try {
      const response = await axiosAccountPrivateV2.post(
        "/users/info-by-username",
        payload,
        withSsoAuthorization(ssoAccessToken)
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDepartmentDivisions: async function (departmentId: number): Promise<any> {
    try {
      const response = await axiosAccountPrivate.get(
        `/department/${departmentId}/divisions`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getListDepartmentByIds: async function (
    departmentIds: number[]
  ): Promise<any> {
    try {
      const response = await axiosAccountPrivate.get(`department/list`, {
        params: {
          ids: departmentIds,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  /** `POST /generate-token` (G-Ticket) — xác thực bằng SSO access token. */
  generateTokenGticket: async function (
    username: string,
    ssoAccessToken: string
  ): Promise<any> {
    try {
      const response = await RequestApiGticket.post(
        `/generate-token`,
        { user_name: username },
        withSsoAuthorization(ssoAccessToken)
      );
      return response.data;
    } catch (error: any) {
      return error?.response;
    }
  },

  updateLocale: async function (payload: {
    userId: number;
    locale: string;
  }): Promise<any> {
    const { userId, locale } = payload;
    try {
      const response = await axiosAccountPrivateV2.put(`/users/${userId}`, {
        language: locale,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  checkExistedDepartmentAndRegion: async function (
    departmentName: string,
    region: string
  ) {
    try {
      const response = await axiosAccountPrivate.get(
        `/admin/departments/find-by-filters?name=${departmentName}&region_code=${region}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  checkExistedDepartmentCode: async function (code: string) {
    const encodedCode = encodeURIComponent(code);
    try {
      const response = await axiosAccountPrivate.get(
        `/admin/departments/find-by-filters?code=${encodedCode}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  checkExistedDivisionCode: async function (code: string) {
    const encodedCode = encodeURIComponent(code);

    try {
      const response = await axiosAccountPrivate.get(
        `/admin/divisions/find-by-filters?code=${encodedCode}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  checkExistedDivisionName: async function (_name: string) {
    try {
      const response = await axiosAccountPrivate.get(
        `/admin/divisions/find-by-filters?name=${_name}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getDepartmentInfoById: async function (_id: any) {
    try {
      const response = await axiosAccountPrivate.get(
        `/admin/departments/${_id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getDivisionInfoById: async function (_id: any) {
    try {
      const response = await axiosAccountPrivate.get(`/admin/divisions/${_id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getUsersInDepartment: async function (params: {}, wsCode: any) {
    try {
      if (params) {
        axiosAccountPrivate.defaults.params = params;
        const res: any = await axiosAccountPrivate.get(wsCode);
        if (res) {
          if (res.data) {
            return res.data;
          }
        }
      }
    } catch (error: any) {
      throw error;
    }
  },
  getAppList: async function (config: any) {
    try {
      const res: any = await axiosAccountPrivate.get("/app/list", config);
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },
  getAssigneeGroup: async function (params: any) {
    try {
      cancelToken();
      source = axios.CancelToken.source();
      const res: any = await fetchWithEtagSafe(
        axiosAccountPrivateV2,
        "/teams",
        {
          params,
          cancelToken: source.token,
        },
        "teams"
      );
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },
  getAssigneeGroupMetadata: async function (params: any) {
    try {
      const res: any = await axiosAccountPrivateV2.get("/teams", {
        params,
      });
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },
  getAssigneeGroupById: async function (id: any) {
    try {
      const res: any = await axiosAccountPrivateV2.get(`/teams/${id}`);
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },
  getAllUsersAndTeams: async function (id: any) {
    try {
      const res: any = await axiosAccountPrivate.get(`/user-teams`);
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },
  getListUserSettings: async function (params: any) {
    try {
      const res: any = await axiosAccountPrivateV2.get(`/admin/users/paging`, {
        params,
      });
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },
  updateUser: async function (id: any, payload: any) {
    try {
      const res: any = await axiosAccountPrivateV2.put(
        `/admin/users/${id}`,
        payload
      );
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },

  exportListUserSettings: async function (params: any) {
    try {
      const res: any = await axiosAccountPrivateV2.get(`/admin/users/export`, {
        params: params,
        responseType: "blob",
      });
      return res;
    } catch (error: any) {
      throw error;
    }
  },

  downloadTemplate: async function () {
    try {
      const res: any = await axiosAccountPrivateV2.get(
        `/admin/users/download-template`
      );
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },

  getListWorkSpaces: async function () {
    try {
      const res: any = await axiosAccountPrivateV2.get(`workspaces`);
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },
  getListRolesV2: async function () {
    try {
      const res: any = await axiosAccountPrivateV2.get(`admin/roles`);
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },

  getUsersModule: async function (
    options: {
      params?: any;
      config?: any;
    } = {}
  ) {
    try {
      const { params, config = {} } = options || {};
      const requestConfig = {
        ...config,
        ...(params !== undefined ? { params } : {}),
      };
      const res: any = await fetchWithEtagSafe(
        axiosAccountPrivateV2,
        "/users/module",
        requestConfig,
        "usersModule"
      );
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },

  getUserInfoV2ById: async function (id: any) {
    try {
      const res: any = await axiosAccountPrivateV2.get(
        `users/info-full/${id}?has_mobile=1`
      );
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },
  getUserInfoById: async function (id: any) {
    try {
      const res: any = await axiosAccountPrivateV2.get(`users/info/${id}`);
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },

  getUserAdminInfoV2ById: async function (id: any) {
    try {
      const res: any = await axiosAccountPrivateV2.get(
        `/admin/users/info/${id}`
      );
      return res.data;
    } catch (error: any) {
      throw error;
    }
  },
  checkIsOwnerAndIsConcurrenlyManagers: async function (id: any) {
    try {
      let params: any = {
        relations: ["workspace.owner", "jobApplies.workspace"],
      };
      const res: any = await axiosAccountPrivateV2.get(`/users/info/${id}`, {
        params,
      });

      return res?.data?.data;
    } catch (error: any) {
      throw error;
    }
  },

  importListUserSettings: async function (formData: any) {
    try {
      const res: any = await axiosAccountPrivateV2.post(
        `/admin/users/import`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        }
      );
      return res;
    } catch (error: any) {
      throw error;
    }
  },
  getAllUserV2Post: async function (body: any = {}): Promise<any> {
    try {
      const response = await axiosAccountPrivateDomainV2.post(
        "/users/module",
        body
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getAllowRankByUserId: async (params: any) => {
    try {
      const res = await axiosAccountPrivateDomainV2.get("/users/get-by-level", {
        params,
      });
      return res.data;
    } catch (error: any) {
      if (error) {
        return error.code;
      }
    }
  },
};
